import React, {useEffect, useState} from "react";
import {Form, DatePicker, Select} from "antd";
import { getCustomerAsSelect } from "../../services/serviceCustomer";
import { getBrandsAsSelect } from "../../services/serviceBrand";
import { getEmployeesAsSelect } from "../../services/serviceEmployee";
import config from "../../config";

const {RangePicker} = DatePicker;

const appointmentStatus = [
    {value: 0, label: 'OLUMLU'},
    {value: 2, label: 'BEKLİYOR'},
    {value: 1, label: 'OLUMSUZ'}
]


const AppointmentReportFilters = () => {
    const [customers, setCustomers] = useState([]);
    const [brands, setBrands] = useState([]);
    const [employee, setEmployee] = useState([]);

    useEffect(() => {
        getEmployeesAsSelect()
            .then(({data}) => {
                if(data && data.length) {
                    const structured = data.map(item => {
                        return {value: item.value, label: item.label}
                    })

                    setEmployee(structured);
                }
            })
    }, []);
    useEffect(() => {
        getBrandsAsSelect()
            .then(({data}) => {
                if(data && data.length) {
                    const structured = data.map(item => {
                        return {value: item.key, label: item.label}
                    })

                    setBrands(structured);
                }
            })
    }, []);
    useEffect(() => {
        getCustomerAsSelect()
            .then(({data}) => {
                if(data && data.length) {
                    const structured = data.map(item => {
                        return {value: item.key, label: item.label}
                    })

                    setCustomers(structured);
                }
            })
    }, []);

    const selectSearch = (input, option) => {
        return (option?.label ?? '').toLowerCase().includes(input.toLowerCase());
    }

    return(
        <React.Fragment>
             <Form.Item
                name={'dateRange'}
                label={'Başlangıç Tarihi'}
                rules={[
                    {required: true, message: 'Bu Alan Zorunludur'}
                ]}
            >
                <RangePicker format={config.userDateFormat} />
            </Form.Item>
            <Form.Item
                name={'brandId'}
                label={'Marka'}
            >
                <Select showSearch options={brands} filterOption={selectSearch} allowClear />
            </Form.Item>
            <Form.Item
                name={'customerId'}
                label={'Müşteri'}
            >
                <Select showSearch options={customers} filterOption={selectSearch} allowClear />
            </Form.Item>
            <Form.Item
                name={'employee'}
                label={'Çalışan'}
                rules={[
                    {required: true, message: 'Bu Alan Zorunludur'}
                ]}
            >
                <Select showSearch options={employee} filterOption={selectSearch} allowClear />
            </Form.Item>
            <Form.Item
                name={'status'}
                label={'Randevu Durumu'}
            >
                <Select showSearch options={appointmentStatus} filterOption={selectSearch} allowClear />
            </Form.Item>
        </React.Fragment>
    )
}

export default AppointmentReportFilters;